module.exports = "https://www.gc-pro.gnp.com.mx/c64d30bfa05d268867457c109e6bf204.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-cobranza-gm.svg
// module id = 8078
// module chunks = 0